import React from 'react';
import styled from "styled-components";
import Bujny from "../../Assets/bujny.svg"
import Ziemiszewska from "../../Assets/ziemiszewska.svg"
import Hansen from "../../Assets/hansen.svg"
import Pregowski from "../../Assets/pregowski.svg";
import Bottema from "../../Assets/bottema.svg";
import Byoung from "../../Assets/byoung.svg";
import Susan from "../../Assets/susan.svg";
import Barnabas from "../../Assets/barnabas.svg";
import Violetta from "../../Assets/violetta.svg";


const JuryEnglish = () => {
    return (
        <Wrapper>
            <Content>
                <h1>Final Jury</h1>
                <JuryPair>
                    <JuryImg>
                        <img src={Bujny} alt={"Jarek Bujny"}/>
                    </JuryImg>
                    <JuryText>
                        <h2>Jarek Bujny</h2>
                        <p>Contest originator. Graphic designer, visual artist, curator, lecturer.</p>
                        <p>Creator of posters on
                            socially engaged issues. Researches visual communication in the areas of social tensions and
                            health problems. He runs the Graphic Design Studio at the Faculty of Art, University of
                            Warmia and Mazury. He is a finalist in many poster competitions and has been awarded at;
                            Poster Bolivia Bienniale 2019 BiceBi 2019, PosterFest 2018 in Chorzow, Taipei International
                            Design Award 2016, Graphis Protest Posters 2, Satyrykon 2022, among others. His posters
                            have been exhibited in major poster competitions around the world in Venezuela, Mexico,
                            China, France, Germany, Spain, Portugal, Turkey, USA, etc. He has conducted graphic design
                            workshops with students in Germany, Israel, Finland and Lithuania. Curator of exhibitions in
                            Canada, France, Germany. DAAD scholarship holder.</p>
                        <p>Runs graphic studio bujny.com realising projects for companies and cultural institutions and
                            publishing houses.</p>
                    </JuryText>
                </JuryPair>
                <JuryPair>
                    <JuryImg>
                        <img src={Ziemiszewska} alt={"Agnieszka Ziemiszewska"}/>
                    </JuryImg>
                    <JuryText>
                        <h2>Agnieszka Ziemiszewska</h2>
                        <p>Graphic designer, educator and art curator</p>
                        <p> Her works have been presented all over the world. She has been awarded numerous
                            distinctions and awards. </p>
                        <p>Currently Agnieszka is a professor at the Faculty of the New Media Arts at the
                            Polish-Japanese Academy of Information Technology in Warsaw.</p>
                        <p> Agnieszka has been part of juries and committees in national and international graphic
                            design competitions and events. She has also curated and co-organized multiple exhibitions
                            in Poland and abroad. Portfolio online: www.ziemi.art.pl</p>
                    </JuryText>
                </JuryPair>
                <JuryPair>
                    <JuryImg>
                        <img src={Hansen} alt={"Rikke Hansen"}/>
                    </JuryImg>
                    <JuryText>
                        <h2>Rikke Hansen</h2>
                        <p>Graphic Designer and Educator. For several years she has been working with product
                            development, branding and consulting for companies and organisations. Currently she
                            teaches a variety of design courses at different design schools and universities in Denmark
                            and abroad. She works on and researches design development projects and has her own
                            design studio doing print and digital design, and is also an owner of a letterpress
                            workshop.
                            Vice Chairman at the Danish Association for Book Crafting. Appointed External Examiner at
                            The higher artistic educational programmes by the Ministry of Higher Education and
                            Science.</p>
                        <p>Juror at the 14th BICM, International Poster Biennial Mexico. Cyprus Poster Triennial.
                            Graphis Talent Award. Ukrainian Design: The Very Best Of. International Poster Biennial
                            Lublin. India’s Best Design Award, BICeBé International Poster Biennial Bolivia 2021. 11th
                            Poster Triennial Trnava, Ecuador Poster Biennial, TISDC Taiwan International Student
                            Design Competition.</p>
                        <p> COFOD Excelence Award winner. Graphis Platinum, Gold and Silver Awards. China
                            International Poster Biennial Silver Award. MutzurWut winner, International Poster
                            Biennale Lublin 1st Prize Award. KIDC Excellence Award. Danish Art Foundation Work
                            Grant.</p>
                        <p> She has been exhibiting, giving lectures &amp; workshops internationally in Europe, Middle
                            East,
                            Asia and America. More info www.wheelsandwaves.dk</p>
                    </JuryText>
                </JuryPair>
                <JuryPair>
                    <JuryImg>
                        <img src={Pregowski} alt={"Nikodem Pręgowski"}/>
                    </JuryImg>
                    <JuryText>
                        <h2>Nikodem Pręgowski</h2>
                        <p>Graphic designer, creator of posters and illustrations. Graduate of the Nicolaus Copernicus
                            University, where as Head of the Department of Graphic Design he teaches students, among
                            other things, book design, illustration, as well as lettering and typography. Founder of the
                            publishing house „Na przykład”. Winner of dozens of awards in the field of poster design.
                            His
                            works have been exhibited, among others, in Belgium, Belarus, the Netherlands, China, the
                            Czech
                            Republic, Ecuador, Estonia, Finland, Iran, Peru, Russia, Slovakia, Turkey and the USA.</p>
                    </JuryText>
                </JuryPair>
                <JuryPair>
                    <JuryImg>
                        <img src={Bottema} alt={"Joost Bottema"}/>
                    </JuryImg>
                    <JuryText>
                        <h2>Joost Bottema</h2>
                        <p>Teacher, professor, graphic designer, author.</p>
                        <p> Professor, head of the Visual Communication Department at the Merz Akademie, Stuttgart,
                            Germany. Experienced designer in classic graphic design and online publishing platforms
                            (web to print). Published novels and articles in which design, art, pattern and structure
                            are
                            placed in a broad perspective.</p>
                        <p>Lives in Amsterdam.
                        </p>
                    </JuryText>
                </JuryPair>

                <h1>Preselection Jury</h1>

                <JuryPair>
                    <JuryImg>
                        <img src={Byoung} alt={"Byoung Il Sun"}/>
                    </JuryImg>
                    <JuryText>
                        <h2>Byoung Il Sun</h2>
                        <p>Since 1995, he has been a professor in Visual Information Design at Namseoul University. He
                            is a graduate of Visual communication design in Hongik University, wherehe receiving his
                            master’s degree in 2005. (Ph., D. degree in Arts). Byoungil-Sun has been awarded various
                            prizes such as the Presidential Award for his contribution to the development of design at
                            the Government of the Republic of Korea. International Awards Golden Bee, Graphis,
                            Taiwan, Red dot, Gdie, Ekoplakt, Information war, World without violence, Poster for
                            tomorrow and 160 int’l selections with posters.</p>
                        <p> He has also served on the juries of numerous international design competitions such as
                            Ukraine, Norway, Slovakia, Belarus , Lublin, France, Iran, China, Turkey, Korea. He has
                            participated in solo exhibitions, both in Korea and abroad (notably in Hungary, Romania,
                            London, Canberra, Osaka, Akita, Beijing, Turkey, Indonesia. Poland).</p>
                        <p>He was the Chair at the Hongik Communication Design Forum in 2011 and at Korea Institute
                            of Cultural Product &amp; Design in 2005 over the years. Poster Collections : Library of
                            congress
                            washington DC, USA, Moscow Golden Bee, Colorado University, Lahti, Chaumont, Toyama,
                            Mexico, Beijing, 4th Block kharkov, Modium museum Seoul,Iang gallery Seoul, Shunzen
                            Museum China. Taiwan cpc center.</p>
                    </JuryText>
                </JuryPair>
                <JuryPair>
                    <JuryImg>
                        <img src={Susan} alt={"Susana Machicao Pacheco"}/>
                    </JuryImg>
                    <JuryText>
                        <h2>Susana Machicao Pacheco</h2>
                        <p>Bolivian visual communicator and graphic designer with more than 20 years of experience.</p>
                        <p> Director of the Bolivia Poster Biennial BICeBé, Regional Coordinator of the Tipos Latinos
                            Biennial of Latin American Typography. Founder and director of LATAM_D, a space that
                            brings together fashion, industrial, product and graphic designers from Latin America.
                            Founder and director of the community of Graphic Designers Bolivia and creator of the
                            international project Mujeres Diseñadoras (Women Designers).</p>

                        <p>In 2016, she was recognized as a Design Professional of the University of Palermo in the
                            Latin American Forum of Design Schools, Ambassador in the Council of Latin American
                            Design Ambassadors of the University of Palermo in Argentina, Member of the Advisory
                            Committee BIAPE.Barcelona International Annual Poster Exhibition, Honorary Member of
                            the International Poster Biennial of Warsaw, Associate Member of the China International
                            Design Educator Association C-IDEA, Founding Member of CAMEBOL Chamber of Women
                            Entrepreneurs of Bolivia.</p>
                        <p>She has been an international juror and speaker and workshop leader at various national and
                            international events. Also given workshops at biennials and design festivals in countries
                            such
                            as France, Mexico, Peru, Ecuador, Argentina, Ukraine, Colombia, Paraguay, among others.
                            Her work has participated in several exhibitions and biennials around the world.</p>
                    </JuryText>
                </JuryPair>
                <JuryPair>
                    <JuryImg>
                        <img src={Barnabas} alt={"Barnabas Wettnon"}/>
                    </JuryImg>
                    <JuryText>
                        <h2>Barnabas Wettnon</h2>
                        <p>Ass. Prof Barnabas Wetton is Joint Leader of Communication at Designskolen Kolding in
                            Denmark</p>
                        <p>After training as an artist in the UK he went on to work on a bridge building project in
                            Peru,
                            reported for the BBC World Service and painted a series of art billboards in London. He is
                            driven by a fascination of the spaces formed between words, typography and images and
                            how to engage viewers in visual and embodied narratives. Two of his teaching projects are
                            part of the permanent collection in MoMA New York and together with Rikke Hansen he has
                            been instrumental in developing design techniques to break down political barriers between
                            Israel and Palestine.
                        </p>
                    </JuryText>
                </JuryPair>
                <JuryPair>
                    <JuryImg>
                        <img src={Violetta} alt={"Violetta Kulikowska-Parkasiewicz"}/>
                    </JuryImg>
                    <JuryText>
                        <h2>Violetta Kulikowska-Parkasiewicz</h2>
                        <p>Director of the Institute of Fine Arts at the University of Warmia and Mazury in Olsztyn,
                            professor at the university, runs an intermedia studio. She completed her diploma in the
                            field
                            of graphic arts and deals with artistic drawing. Winner of many art competitions: Triennale
                            of
                            Polish Contemporary Drawing - Lubaczów, International Drawing Biennale in Pilsen,
                            International Drawing Competition, Wrocław, Kalisz Biennale of Drawing and Graphics
                            „Próba1”, Sacrum Art Triennale in Częstochowa, two-time winner of the Grand Prix of the
                            Olsztyn Art Biennale - O Medal Prezydenta, Grand Prix winner at the National Winter Salon
                            in 2022.President of the Wyłom Foundation. Member of the Warmia and Mazury
                            Association Zachęta of Fine Arts in Olsztyn. Author of several individual exhibitions.</p>
                    </JuryText>
                </JuryPair>
                <JuryPair>
                    <JuryImg>
                        <img src={Bujny} alt={"Jarek Bujny"}/>
                    </JuryImg>
                    <JuryText>
                        <h2>Jarek Bujny</h2>
                        <p>Contest originator. Graphic designer, visual artist, curator, lecturer.</p>
                        <p>Creator of posters on
                            socially engaged issues. Researches visual communication in the areas of social tensions and
                            health problems. He runs the Graphic Design Studio at the Faculty of Art, University of
                            Warmia and Mazury. He is a finalist in many poster competitions and has been awarded at;
                            Poster Bolivia Bienniale 2019 BiceBi 2019, PosterFest 2018 in Chorzow, Taipei International
                            Design Award 2016, Graphis Protest Posters 2, Satyrykon 2022, among others. His posters
                            have been exhibited in major poster competitions around the world in Venezuela, Mexico,
                            China, France, Germany, Spain, Portugal, Turkey, USA, etc. He has conducted graphic design
                            workshops with students in Germany, Israel, Finland and Lithuania. Curator of exhibitions in
                            Canada, France, Germany. DAAD scholarship holder.</p>
                        <p>Runs graphic studio bujny.com realising projects for companies and cultural institutions and
                            publishing houses.</p>
                    </JuryText>
                </JuryPair>
            </Content>
        </Wrapper>
    )
}

export default JuryEnglish

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 12% 10% 0 10%;
  position: relative;

  h1 {
    font-family: Lato;
    color: #E44432;
    font-weight: 800;
    margin-top: 10px;
    padding: 10px;
    border-radius: 50px;
    text-transform: uppercase;

    @media (max-width: 768px) {
      text-align: center;
    }
  }
`

const Content = styled.div`
  display: flex;
  flex-direction: column;
  width: 700px;

  @media (max-width: 768px) {
    width: 100vw;
  }
`

const JuryPair = styled.div`
  display: flex;
  flex-direction: Row;
  align-items: center;
  width: 100%;
  height: auto;
  margin-bottom: 20px;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`

const JuryImg = styled.div`
  width: 280px;

  img {
    max-width: 280px;
    @media (max-width: 768px) {
      width: 220px;
    }
  }

  @media (max-width: 768px) {
    width: 240px;
  }
`

const JuryText = styled.div`
  max-width: 400px;
  margin-left: 20px;

  h2 {
    font-family: Lato;
    font-weight: 400;
    font-size: 24px;
    color: black;
  }

  p {
    font-family: Lato;
    font-weight: 400;
    font-size: 14px;
    line-height: 1.5;
    color: black;
  }

  @media (max-width: 768px) {
    max-width: 350px;
    padding: 0 10px;
  }
`

